import { useMemo } from 'react'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table.js'
import {
  ColumnAdapter,
  ConditionFeatureFlag,
  ConditionStatementActionOutput,
  ConditionTextOperator,
  IActionType,
} from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { NodeOutputOption } from '@/shared/action.types'
import { appIconKeys } from '@/shared/icons'

import { RenderColumn } from '../RenderColumn'
import VariableActionOutput from '../VariableSelectV2/VariableActionOutput'
import { useConditionRepeaterContext } from './ConditionRepeaterContext'
import { useConditionSelectContext } from './ConditionSelectContext'

export function ConditionActionOutputDD() {
  const { id, setOpen, isRhs, index, actions } = useConditionSelectContext()
  const { onChange, value } = useConditionRepeaterContext()
  const key = isRhs ? 'rhs' : 'lhs'

  return (
    <VariableActionOutput
      id={id}
      onChange={(e) => {
        const nextCond = [...value.conditions]
        if (!isRhs) {
          nextCond[index].operator = ConditionTextOperator.IsEqual
        }
        nextCond[index] = {
          ...nextCond[index],
          [key]: {
            ...e,
            flag: ConditionFeatureFlag.ActionOutput,
          },
        }
        onChange?.({ isAny: value.isAny, conditions: nextCond })
        setOpen(false)
      }}
      onHide={() => setOpen(false)}
      options={actions}
    />
  )
}

export function ConditionActionOutputStatement({
  allActions,
  statement,
}: {
  allActions: NodeOutputOption[]
  statement: ConditionStatementActionOutput
}) {
  const actionId = (statement as any)?.actionId
  const action = allActions?.find((a) => a.id === actionId)

  const { tables: tblOptions } = useDbClientContext()
  const tbl = typeof statement.value === 'string' ? undefined : statement.value?.tableId
  const col = typeof statement.value === 'string' ? undefined : statement.value?.colId

  const [_, colObj] = useMemo(() => {
    const selTbl = tblOptions.find((tb) => tb.id === tbl)
    if (selTbl) {
      let columns = [{ id: '_id', name: 'Row ID', type: ColumnTypes.RowID } as ColumnAdapter, ...selTbl.columns]
      return [selTbl, columns.find((c) => c.id === col)]
    }
    return [selTbl, undefined]
  }, [tblOptions, tbl, col])

  if (action?.actionType === IActionType.TemporaryVariable) {
    return (
      <div className='flex items-center gap-1'>
        <MaterialIcon size={16} icon={appIconKeys.actionOutput} />
        <span>{action?.label}</span>
      </div>
    )
  }

  return (
    <div className='flex-c min-w-0'>
      <div className='text-m-ss uppercase' title={action?.label}>
        <MaterialIcon size={16} icon={appIconKeys.actionOutput} />
      </div>
      <RenderColumn col={colObj} className='min-w-0' textClassName='txt' width={14} height={14} withStyle />
    </div>
  )
}
